module.exports = require('./lib/range')
